import * as React from 'react';
import { WebAPI } from '../../../../MedicareProAPI/API/WebAPI';
import StyledModal from '../../StyledModal';
import { UserRepository } from '../../../../MedicareProAPI/Repositories/User/UserRepository';
import { MultiSelectModal } from './MultiSelectModal';
import type { SelectMap, SelectMapGroup } from '../../../Utilities/SelectMap';

export interface UserLeadStatusSelectProps {
  userAccessToken: string;
  userId: number;
  disabled?: boolean;

  onChange?: (userLeadStatus: string[]) => void;

  value: string[];
}

export const UserLeadStatusSelect = (props: UserLeadStatusSelectProps): React.JSX.Element => {
  const [userLeadsStatuses, setUserLeadsStatuses] = React.useState<any>(null);
  const [userLeadsStatusesLoading, setUserLeadsStatusesLoading] = React.useState<boolean>(false);

  const [value, setValue] = React.useState<string[]>(props.value);

  const webAPI = new WebAPI();
  webAPI.setAccessToken(props.userAccessToken);

  const userRepository = new UserRepository();
  userRepository.setAccessToken(props.userAccessToken);

  React.useEffect(() => {
    setUserLeadsStatusesLoading(true);

    webAPI.getUserLeadsStatuses(props.userId).then((response) => {
      setUserLeadsStatusesLoading(false);

      const newLeadStatuses = Array.from(response.data, (responseItem: any): SelectMapGroup => {
        const items = Array.from(responseItem.items, (groupItems: any): SelectMap => {
          return {
            label: groupItems.label,
            value: groupItems.label,
          };
        });

        return {
          label: responseItem.label,
          items: items,
        };
      });

      setUserLeadsStatuses(newLeadStatuses);
    });
  }, []);

  React.useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  return (
    <>
      <div>
        {userLeadsStatusesLoading === true && (
          <div className="alert small alert-info" role="alert">
            <i className="fas fa-spinner fa-spin ml-2"></i> Loading....
          </div>
        )}
        {userLeadsStatusesLoading === false && userLeadsStatuses && (
          <MultiSelectModal
            disabled={props.disabled}
            value={value}
            options={userLeadsStatuses}
            modalSaveButtonLabel="Save Changes"
            modalTitle="Select Lead Statuses"
            buttonSelectLabel="Choose Statuses"
            buttonEditLabel="Edit Statuses"
            onChange={(newValue) => {
              setValue(newValue);

              if (props.onChange) {
                props.onChange(newValue);
              }
            }}
          />
        )}
      </div>
    </>
  );
};
